module.exports = __webpack_public_path__ + "img/whatsapp-instruction-2.a1d02b75.png";